import {createWidgetPreloader} from '../source/preloader'

///////////////////////////////////////////////////////////////////////////////

let widgetPreloader = createWidgetPreloader({
  resolvers: {
    initialConfig: async () => {
      return {
        customConfig: require('../config/config.**.yml'),
      }
    },
    preloaderCSS: () => import('./styles/preloader'),
    widgetCSS: () => import('./styles/widget'),
  },
})

///////////////////////////////////////////////////////////////////////////////

window['rnw'] = window['rnw'] || {}
window['rnw']['tamaro'] = widgetPreloader

widgetPreloader.events.afterCreate.subscribe((event) => {
  const api = event.data.api
  const data = api.paymentForm.data

  //is there really no better way to get todays date in JS ???
  var todayObj = new Date();
  var todayDay = ("0"+todayObj.getDate()).slice(-2);
  var todayMonth = ("0"+(todayObj.getMonth()+1)).slice(-2);
  var today = todayDay+'.'+todayMonth+'.'+todayObj.getFullYear();
  data.stored_sf_News_subscription_date__c = today;
  data.stored_sf_Newsletter__c = 'Pending';
  data.stored_sf_Last_News_Subscription_Source__c = 'wwf-hu-monthly';
})
